import constants from '@/services/constants'
import menuTemplate from '@/services/menu'
import { copyFile } from 'fs';
const state = {
  menu: []
}
const getters = {
  menuList (state) {
    return state.menu
  }
}
const actions = {
  'INIT_MENU': ({commit, dispatch}, payload) => {
    let passport = payload
    let roleInPassport = [...passport.roles]
    let menu = [...menuTemplate]
    if(passport.isAdmin) { // super user see all menu
      console.log('access menu > admin case')
      menu.forEach(m => {
        m.show = true
      })
      let menuFilter = menu.filter(o => o.show === true)
      commit('SET_MENU', menuFilter)
      return
    }
    if (passport.upn.includes('@chevron.com')) { // email include @chevron.com
      console.log('access menu > case1 : include')
      menu.forEach(m => {
        m.show = true
        if(m.role && m.role.length > 0) {
          let anyRole = roleInPassport.some(o => m.role.findIndex(x => x == o) > -1)
          if(!anyRole)
            m.show = false
        }
        if (m.ignoreValidate) {
          m.show = true
        }
        if(m.subGroup) {
          m.subGroup.forEach(x => {
            x.show = true
            if(x.role && x.role.length > 0) {
              let anyRole = roleInPassport.some(o => x.role.findIndex(p => p == o) > -1)
              if(!anyRole)
                x.show = false
            }
          })
        }
      })
      let menuFilter = menu.filter(o => o.show === true)
      // filter subgroup
      menuFilter.forEach(o => {
        o.subGroup = [...o.subGroup.filter(o => o.show == true)]
      })
      commit('SET_MENU', menuFilter)
    } else { // email exclude @chevron.com
      console.log('access menu > case2 : exclude')
      if (roleInPassport.some(o => o == constants.USER_ROLE.WESTE_CONTRACTOR || o == constants.USER_ROLE.BUYER)) {
        console.log('access menu > case2 : have role')
        menu.forEach(m => {
          if (m.label == 'Receive Material') {
            m.show = true
            m.subGroup.forEach(x => {
              if (x.label == 'Contaminate') {
                x.show = true
              } else {
                x.show = false
              }
            })
          } else {
            m.show = false
            if (m.subGroup) {
              m.subGroup.forEach(x => {
                x.show = false
              })
            }
          }
          if (m.ignoreValidate) {
            m.show = true
          }
        })
      } else {
        console.log('access menu > case2 : have no role')
        menu.forEach(m => {
          m.show = false
          if (m.subGroup) {
            m.subGroup.forEach(x => {
              x.show = false
            })
          }
        })
      }
      let menuFilter = menu.filter(o => o.show === true)
      // filter subgroup
      menuFilter.forEach(o => {
        o.subGroup = [...o.subGroup.filter(o => o.show == true)]
      })
      commit('SET_MENU', menuFilter)
    }
  }
}
const mutations = {
  'SET_MENU': (state, data) => {
    state.menu = data
  },
}

export default {
  actions, 
  getters, 
  state, 
  mutations
}